export default __webpack_public_path__ + "static/media/01.5786c2c4.jpg";